import createWrappedField from './createWrappedField'
import DTP from '../DateTimePicker'

export default createWrappedField({
  Component: DTP,
  name: 'DDIDateTimePicker'
})
